import React from "react";
import { BiLogOut } from "react-icons/bi";
import { Spinner } from "react-rainbow-components";
import { useUser } from "../../store/UserStore";
import * as Components from "./index.style";
import { useHistory } from "react-router-dom";
import { menuItem } from "./index.menuItem";
import { useChatList } from "../../store/ChatList";
import Logo from "../../components/common/Logo";

const SideNav = () => {
  const [showSideBar, setShowSideBar] = React.useState<string>("false");
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const userContext = useUser();
  const history = useHistory();
  const user = useUser();
  const menus = menuItem(user.userData?.role || "");
  const handleClickLogout = async () => {
    setIsLoading(true);
    localStorage.removeItem("token");
    user.setUserData(undefined);
    history.replace("/login");
    setIsLoading(false);
  };
  const MenuOnClick = () => {
    showSideBar === "false" ? setShowSideBar("true") : setShowSideBar("false");
  };
  const { chats } = useChatList();
  const isUnRead = chats.find((chat) => chat.isRead === false);

  const renderMenuItem = menus.map((item, index) => {
    return item.isDisabled ? (
      <></>
    ) : (
      <li key={index}>
        <Components.NavLink
          isselected={item.path === window.location.pathname ? "true" : "false"}
          to={item.path}
          showsidebar={showSideBar}
        >
          <Components.LogoDiv>{item.icon}</Components.LogoDiv>
          <Components.LinkName showsidebar={showSideBar}>
            {item.linkName}
          </Components.LinkName>
          {isUnRead && item.path === "/chat" && <Components.PointNotify />}
        </Components.NavLink>
        <div className="tooltip">{item.linkName}</div>
      </li>
    );
  });

  return (
    <>
      <Components.BubbleMenu>
        <Components.Menu
          size="20px"
          onClick={MenuOnClick}
          showsidebar={showSideBar}
        />
        {isUnRead && <Components.PointNotify />}
      </Components.BubbleMenu>
      <Components.SideBar showsidebar={showSideBar}>
        <div style={{ padding: "6px 0 0 24px" }}>
          <Logo showsidebar={showSideBar === "true"} />
          <Components.Menu
            size="20px"
            onClick={MenuOnClick}
            showsidebar={showSideBar}
          />
        </div>

        <ul>{renderMenuItem}</ul>
        <Components.ProfileContent showsidebar={showSideBar}>
          {isLoading ? (
            <div className="profile">
              <div className="profile_details">
                <Components.ImageProfile
                  src={userContext.userData?.imageUrl}
                  size="medium"
                  title={userContext.userData?.firstName}
                  assistiveText={userContext.userData?.firstName}
                  initials={userContext.userData?.firstName}
                />
                <div className="name_role">
                  <div className="name">
                    {userContext.userData?.firstName +
                      " " +
                      userContext.userData?.lastName}
                  </div>
                  <div className="role">{userContext.userData?.role}</div>
                </div>
              </div>
              <Components.LogoDiv
                className="logout"
                onClick={handleClickLogout}
              >
                <BiLogOut size="25px" />
              </Components.LogoDiv>
            </div>
          ) : (
            <Spinner />
          )}
        </Components.ProfileContent>
      </Components.SideBar>
    </>
  );
};

export default SideNav;
